import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdTestingControlsSuspense } from "api/generated/users/users";

export function useTestingControlsForUserQuery(userId: number) {
    return useGetUsersUserIdTestingControlsSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
